import styled from 'styled-components';

export const AuthLayoutWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`;
